<template>
  <div class="reports-client-details p-5">
    <h1 class="title pb-5 pt-2">Detalhes do cliente</h1>

    <button class="btn-close pt-6 pt-lg-2" @click="$emit('close')">
      <i class="icon-x"></i>
    </button>

    <div class="d-flex flex-row justify-content-between">
      <div v-if="client.product && client.product.picture">
        <img :src="client.product.picture" />
      </div>
      <div
        class="d-flex align-items-center ml-5 mr-auto"
        v-if="client.product && client.product.name"
      >
        <div class="name">{{ client.product.name }}</div>
      </div>
      <div class="d-flex align-items-center">
        <span
          :class="client.finished_order ? 'active-badge' : 'incomplete-badge'"
        >
          <small>{{
            client.finished_order ? "Realizada" : "Incompleta"
          }}</small>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 pt-6">
        <small>Nome do cliente</small>
        <div class="form-control">{{ client.name }}</div>
      </div>

      <div class="col-lg-6 pt-6">
        <small>E-mail do cliente</small>
        <div class="form-control">{{ client.email }}</div>
      </div>

      <div class="col-lg-6 pt-6" v-if="client.phone">
        <small>Telefone</small>
        <div class="form-control">{{ client.phone }}</div>
      </div>

      <div class="col-lg-6 pt-6" v-if="client.instagram">
        <small>Instagram</small>
        <div class="form-control">{{ client.instagram }}</div>
      </div>

      <template v-if="client.address">
        <div class="col-lg-6 pt-6" v-if="client.address.zipcode">
          <small>CEP</small>
          <div class="form-control">{{ client.address.zipcode }}</div>
        </div>

        <div class="col-lg-6 pt-6" v-if="client.address.address">
          <small>Endereço</small>
          <div class="form-control">{{ client.address.address }}</div>
        </div>

        <div class="col-lg-6 pt-6" v-if="client.address.number">
          <small>Número</small>
          <div class="form-control">{{ client.address.number }}</div>
        </div>

        <div class="col-lg-6 pt-6" v-if="client.address.neighborhood">
          <small>Bairro</small>
          <div class="form-control">{{ client.address.neighborhood }}</div>
        </div>

        <div class="col-lg-6 pt-6" v-if="client.address.complement">
          <small>Complemento</small>
          <div class="form-control">{{ client.address.complement }}</div>
        </div>

        <div class="col-lg-6 pt-6" v-if="client.address.city">
          <small>Cidade</small>
          <div class="form-control">{{ client.address.city }}</div>
        </div>

        <div class="col-lg-6 pt-6" v-if="client.address.state">
          <small>Estado</small>
          <div class="form-control">{{ client.address.state }}</div>
        </div>
      </template>

      <div class="col-lg-6 pt-6" v-if="client.country">
        <small>País</small>
        <div class="form-control">{{ client.country }}</div>
      </div>

      <div class="col-lg-6 pt-6" v-if="client.offer && client.offer.name">
        <small>Oferta</small>
        <div class="form-control">{{ client.offer.name }}</div>
      </div>

      <div class="col-lg-6 pt-6" v-if="client.plan && client.plan.name">
        <small>Plano</small>
        <div class="form-control">{{ client.plan.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    client: Object
  }
};
</script>

<style lang="scss" scoped>
.reports-client-details {
  .btn-close {
    background: none;
    border: none;
    top: 26px;
    right: 22px;
  }

  .title {
    color: rgba(87, 88, 107, 0.88);
    font-size: 18px;
    font-weight: 400;
  }

  .name {
    color: rgba(59, 59, 74, 0.9);
    font-size: 14px;
    font-weight: 400;
  }

  img {
    max-width: 65px;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: 4px;
  }

  .form-control {
    border-radius: 4px;
    border: 1px solid rgba(155, 157, 176, 0.86);
    background: rgba(219, 221, 230, 0.2);
    line-height: 25px;
    color: rgba(87, 88, 107, 0.88);
    min-height: 40px !important;
    height: 40px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
